module.exports = ".lista-resultado {\n    min-height: 215px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/modal/instalacao-produto-modal/instalacao-produto-modal.component.css
// module id = ./src/app/modal/instalacao-produto-modal/instalacao-produto-modal.component.css
// module chunks = main